module.exports = __webpack_public_path__ + "static/media/icon-plus--sheet.3fbf64af.svg";